/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AnalysisClientItemAgeCategoryType = (typeof AnalysisClientItemAgeCategoryType)[keyof typeof AnalysisClientItemAgeCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisClientItemAgeCategoryType = {
  adult: "adult",
  child: "child",
  plannedChild: "plannedChild",
} as const;
